import { render, staticRenderFns } from "./replies_list.vue?vue&type=template&id=a5252eb8"
import script from "./replies_list.vue?vue&type=script&lang=js"
export * from "./replies_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports